import { Component, OnInit } from "@angular/core";
import { AbstractPage } from "../AbstractPage";
import { LoadingController, ModalController, NavController, NavParams } from "@ionic/angular";
import { Router } from "@angular/router";
import { RilevazionePresenzeService } from "../services/rilevazione-presenze-service";
import { Studente } from "../models/didattica/studente";
import { TranslateService } from "@ngx-translate/core";
import { FormBuilder, FormGroup } from "@angular/forms";

@Component({
    selector: 'app-carica-presenze',
    templateUrl: './carica-presenze.page.html',
    styleUrls: ['./carica-presenze.page.scss'],
    standalone: false
})
export class CaricaPresenzePage extends AbstractPage implements OnInit {

    isCsv: boolean = true;
    matricole: string[] = [];
    studenti: Studente[] = [];
    duplicates: string[] = [];
    studentiError: string = "";
    form: FormGroup;
    studentiCaricati: Studente[] = [];
    infoMessage: string;
    noValidStu: boolean = false;
    dupMessage: string;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public router: Router,
        public modalCtrl: ModalController,
        public rilevazionePresenzeService: RilevazionePresenzeService,
        public loadingCtrl: LoadingController,
        public translateService: TranslateService,
        private formBuilder: FormBuilder
    ) {
        super(navCtrl, router);

        this.form = this.formBuilder.group({
            studenti: [
    
            ],
            all: [
                
            ]
        });
    }

    ngOnInit() {
        console.log('ngOnInit CaricaPresenzePage');   
    }
    
    cancel() {
        this.modalCtrl.dismiss();
    }

    public uploadFile(files: FileList){
        console.log(files);
        if(files && files.length > 0) {
           let file = files.item(0); 
             console.log(file.name);
             console.log(file.size);
             console.log(file.type);
             if(file.type !== 'text/csv') {
                this.isCsv = false;
                return;
             }
             else {
                this.isCsv = true;
             }
             let reader = new FileReader();
             reader.readAsText(file);
             reader.onload = (e) => {
                let csv = reader.result as string;
                this.matricole = csv.split(/[;\r\n]+/);

                let matricole = this.matricole;
                this.cercaPresenti(matricole);
             }
          }
      }

      async cercaPresenti(matricole: string[]) {
        let matricole_ = [];
        this.studenti = [];
        this.studentiCaricati = [];
        let studentiErr = [];
        for(const mat of matricole) {
            if(mat !== '' && mat.length <= 20 && !matricole_.includes(mat)) {
                matricole_.push(mat);
                this.form.controls['studenti'].setValue(true);
                this.form.controls['all'].setValue(true);
            }
        }   
        const loader = await this.loadingCtrl.create({
            message: this.translateService.instant('label.richiestaincorso')
          });
          loader.present(); 
        this.rilevazionePresenzeService.cercaStudenti(matricole_).subscribe(stu => {
            stu.forEach(studente => {
              if(studente.id !== null) {
                this.studenti.push(studente);
                this.studentiCaricati.push(studente);
              }
              else {
                studentiErr.push(studente);
                this.studentiError = this.studentiError.concat(studente.matricola + "; ");
              }
            });

            if(stu.length === 0 || studentiErr.length === stu.length) {
              this.noValidStu = true;
            }
            else {
              this.noValidStu = false;
            }

            if(this.studentiError !== null) {
              this.infoMessage = this.translateService.instant('carica-presenza.label.studenti.error', { n: this.studentiError });
            }
            loader.dismiss();
        });
        this.checkDuplicate();
      }

    aggiungiStudente(studente: Studente) {
        console.log('studente', this.form.controls['studenti'].value);
        if(this.form.controls['studenti'].value) {
          this.studentiCaricati.push(studente);
        }
        else {
          let index = this.studentiCaricati.indexOf(studente);
          this.studentiCaricati.splice(index, 1);
        }
      }

      async conferma() {
        await this.modalCtrl.dismiss(this.studentiCaricati);
      }

      selectAll() {
        if(this.form.controls['all'].value) {
          this.form.controls['studenti'].setValue(true);
          this.studentiCaricati = [];
          this.studenti.forEach(studente => {
            this.studentiCaricati.push(studente);
          })
        }
        else {
          this.form.controls['studenti'].setValue(false);
          this.studentiCaricati = [];
        }
      }

      checkDuplicate() {
        this.duplicates = this.matricole.filter((a, i, aa) => aa.indexOf(a) === i && aa.lastIndexOf(a) !== i);

        if(this.duplicates.length != 0) {
          this.dupMessage = this.translateService.instant('carica-presenza.label.studenti.duplicates', { n: this.duplicates });
        }
      }
}